import React from 'react';

// We define styles using React's CSSProperties for type safety.
// This makes it easy to manage styles within the component file.
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    backgroundColor: '#121212', // A modern dark background
    color: '#e0e0e0',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    padding: '2rem',
    boxSizing: 'border-box',
  },
  icon: {
    fontSize: '4rem',
    marginBottom: '1.5rem',
    animation: 'float 3s ease-in-out infinite',
  },
  title: {
    fontSize: 'clamp(2.5rem, 8vw, 4rem)', // Responsive font size
    fontWeight: 'bold',
    color: '#ffffff',
    margin: '0 0 1rem 0',
  },
  subtitle: {
    fontSize: 'clamp(1rem, 4vw, 1.25rem)', // Responsive font size
    maxWidth: '600px',
    lineHeight: 1.6,
    color: '#a0a0a0',
  },
};

// We also add a keyframes animation directly into the document's head
// for the floating effect. This is a clean way to handle simple animations
// without extra libraries.
const keyframes = `
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-15px); }
    100% { transform: translateY(0px); }
  }
`;

/**
 * A simple and stylish "Coming Soon" page component.
 */
const ComingSoonPage: React.FC = () => {
  return (
    <>
      <style>{keyframes}</style>
      <div style={styles.container}>
        <div style={styles.icon}>🚀</div>
        <h1 style={styles.title}>Launching Soon</h1>
        <p style={styles.subtitle}>
          We're putting the final touches on our new website. It's going to be
          worth the wait! Thank you for your patience.
        </p>
      </div>
    </>
  );
};

export default ComingSoonPage;